/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { CompChat, InputButton, Loading, SearchAlert } from '../../../Simple'
import { Menu, Box, Button } from '@mui/material'
import { UsuarioContext } from '../../../../contexts/UsuarioContext'
import { ChatContext } from '../../../../contexts/ChatContext'
import RouterHook from '../../../../contexts/RouterHook'
import styles from './styles'

export default function MenuChat({ open, handleClose, anchorEl }) {
  const serverRouter = RouterHook()
  const contMenuRef = React.useRef(null)
  const contListRef = React.useRef(null)
  const { userUCtx } = React.useContext(UsuarioContext)
  const { sttChatCtx, loadsChat, actionsChatCtx } = React.useContext(ChatContext)

  React.useEffect(() => {
    if (sttChatCtx.chatMNLP || (sttChatCtx.modeChat === 'agendamentos' && !sttChatCtx.pesquisedAgends)) actionsChatCtx.BuscarChatAgendamentos(true)
    else if (sttChatCtx.chatMNLE || (sttChatCtx.modeChat === 'diretos' && !sttChatCtx.pesquisedDirects)) actionsChatCtx.BuscarChatDiretos(true)
  }, [sttChatCtx.modeChat])

  let flagRef = React.useRef(false)
  React.useEffect(() => {
    const handleScroll = () => {
      if (contListRef.current && contListRef.current.scrollTop + contListRef.current.clientHeight >= contListRef.current.scrollHeight - 10) {
        if (sttChatCtx.modeChat === 'agendamentos' && !loadsChat.chatPagination && !flagRef.current) {
          if (sttChatCtx.chatsAgends.length < sttChatCtx.maxScroll) {
            flagRef.current = true
            actionsChatCtx.BuscarChatAgendamentos(false).then(() => {
              flagRef.current = false
            })
          }
        } else if (sttChatCtx.modeChat === 'diretos' && !loadsChat.chatPagination && !flagRef.current) {
          if (sttChatCtx.chatsDirects.length < sttChatCtx.maxScroll) {
            flagRef.current = true
            actionsChatCtx.BuscarChatDiretos(false).then(() => {
              flagRef.current = false
            })
          }
        }
      }
    }

    const currentRef = contListRef.current
    if (currentRef) {
      currentRef.addEventListener('scroll', handleScroll)
    }
    return () => {
      if (currentRef) {
        currentRef.removeEventListener('scroll', handleScroll)
      }
    }
  }, [sttChatCtx.modeChat, loadsChat, sttChatCtx.chatsAgends, sttChatCtx.chatsDirects, sttChatCtx.maxScroll])

  return (
    <Menu
      ref={contMenuRef}
      anchorEl={anchorEl}
      open={open}
      onClose={() => handleClose('chat')}
      onClick={() => {}}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      slotProps={{
        paper: {
          sx: styles.menuPaper,
        },
        list: {
          sx: styles.menuList,
        },
      }}
    >
      <Box sx={styles.containContent}>
        <Box sx={styles.containBtts}>
          <Button
            fullWidth
            sx={sttChatCtx.modeChat === 'agendamentos' ? styles.btnActive : styles.btnInactive}
            style={{ borderRadius: '5px 0px 0px 0px' }}
            onClick={() => {
              if (sttChatCtx.modeChat !== 'agendamentos' && !loadsChat.listChat) actionsChatCtx.handleModeChat('agendamentos')
            }}
          >
            Agendamentos
          </Button>
          <Button
            fullWidth
            sx={sttChatCtx.modeChat === 'diretos' ? styles.btnActive : styles.btnInactive}
            style={{ borderRadius: '0px 5px 0px 0px' }}
            onClick={() => {
              if (sttChatCtx.modeChat !== 'diretos' && !loadsChat.listChat) actionsChatCtx.handleModeChat('diretos')
            }}
          >
            Mensagens Diretas
          </Button>
        </Box>
        <Box
          ref={contListRef}
          sx={{
            ...styles.containList,

            height: `calc(${contMenuRef.current?.children[0].offsetHeight}px - 220px)`,
          }}
        >
          {loadsChat.listChat ? (
            <div className='contain-loading'>
              <Loading text={'Carregando conversas...'} />
            </div>
          ) : sttChatCtx.modeChat === 'agendamentos' ? (
            sttChatCtx.chatsAgends.length > 0 ? (
              sttChatCtx.chatsAgends.map((chat, index) => (
                <React.Fragment key={index}>
                  <CompChat
                    chat={chat}
                    fotoEmpresa={chat.fotoEmpresa}
                    onClick={() => {
                      actionsChatCtx.SelectChatAgend(chat.idchat)
                      serverRouter('chat', userUCtx.usuario.idusuario)
                      handleClose('chat')
                    }}
                  />
                  <Box sx={styles.containLine} />
                </React.Fragment>
              ))
            ) : (
              <SearchAlert text={'Realize um agendamento para iniciar uma conversa.'} />
            )
          ) : sttChatCtx.chatsDirects.length > 0 ? (
            sttChatCtx.chatsDirects.map((chat, index) => (
              <React.Fragment key={index}>
                <CompChat
                  chat={chat}
                  fotoEmpresa={chat.pedido.empresa.urlFoto + chat.pedido.empresa.foto}
                  onClick={() => {
                    actionsChatCtx.SelectChatDirect(chat.idchat)
                    serverRouter('chat', userUCtx.usuario.idusuario)
                    handleClose('chat')
                  }}
                />
                <Box sx={styles.containLine} />
              </React.Fragment>
            ))
          ) : (
            <SearchAlert text={'Para iniciar uma conversa direta, vá até a página do centro esportivo desejado e inicie uma conversa com o gestor'} />
          )}
          {loadsChat.chatPagination && <Loading />}
        </Box>
        <InputButton
          title='Ver todas as conversas'
          onClick={() => {
            serverRouter('chat', userUCtx.usuario.idusuario)
            handleClose('chat')
          }}
          sx={{ margin: '5px 5px 10px 5px', maxWidth: '250px' }}
        >
          Ver todas as conversas
        </InputButton>
      </Box>
    </Menu>
  )
}
